import { useQuery } from '@tanstack/react-query';
import { useGraphneAPI } from '@nexelem/graphne-api';
import { useSimulationId } from './useSimulationId';

export const taskTechnologiesQueryKey = (simulationId: string | number, taskId: string | number) => [
  'simulation-technologies',
  simulationId.toString(),
  taskId.toString(),
];

export const useGetGraphneTaskTechnologies = (taskId: string | number) => {
  const api = useGraphneAPI();
  const { id } = useSimulationId();

  return useQuery({
    queryKey: taskTechnologiesQueryKey(id, taskId),
    queryFn: () =>
      api.getGraphneSimulationSimulationidTasksP1Recipesversionnames({
        simulationId: id.toString(),
        p1: taskId.toString(),
      }),
    enabled: !!id && !!taskId,
  });
};
